// SPDX-License-Identifier: MIT

/**
 * Returns true when `err` is the Postgres raise thrown by the
 * `user_entitlements` quota trigger (SQLSTATE P0001, message
 * "insufficient_idea_quota").  Use this to show a friendly upsell
 * message instead of a generic error.
 */
export function isQuotaError(err: unknown): boolean {
  const e = err as { message?: string; code?: string } | null;
  return !!e && (e.code === 'P0001' || /insufficient_idea_quota/.test(e.message ?? ''));
}
